import { createGetContractBasedDataFetchSlice } from '@cp-shared-15/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';

const testData = {
    outstandingBalance: 1000,
    interestSaving: 10000,
    arrears: 990,
    totalSettlementAmount: 31900,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const { reducer, fetchData } = createGetContractBasedDataFetchSlice<any, DefaultBusinessMarketApiErrorCode>({
    dataName: 'earlySettlement',
    fetchCallback(earlySettlementEndpoint: string) {
        return CpDataApi.get(earlySettlementEndpoint)
            .then(response => response.data ?? testData)
            .catch(() => testData);
    },
});

export default reducer;
export const fetchEarlySettlement = fetchData;
